import { useContext } from 'react'

import { StepperContext } from '@/contexts/stepper'

interface UseStepProps {
  currentStepNumber: number
  updateStep: (step: number) => void
  steps: {
    title: string
  }[]
}

export const useStepper = (): UseStepProps => {
  const { currentStepNumber, setCurrentStepNumber, steps } = useContext(StepperContext)

  const updateStep = (step: number) => {
    setCurrentStepNumber(step)
  }

  return {
    currentStepNumber,
    updateStep,
    steps
  }
}
